"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var _ownKeys = function ownKeys(o) {
    _ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return _ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = _ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseString = exports.parseFile = exports.parseStream = exports.parse = exports.ParserOptions = exports.CsvParserStream = void 0;
var fs = __importStar(require("fs"));
var stream_1 = require("stream");
var ParserOptions_1 = require("./ParserOptions");
var CsvParserStream_1 = require("./CsvParserStream");
__exportStar(require("./types"), exports);
var CsvParserStream_2 = require("./CsvParserStream");
Object.defineProperty(exports, "CsvParserStream", {
  enumerable: true,
  get: function get() {
    return CsvParserStream_2.CsvParserStream;
  }
});
var ParserOptions_2 = require("./ParserOptions");
Object.defineProperty(exports, "ParserOptions", {
  enumerable: true,
  get: function get() {
    return ParserOptions_2.ParserOptions;
  }
});
var parse = function parse(args) {
  return new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(args));
};
exports.parse = parse;
var parseStream = function parseStream(stream, options) {
  return stream.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseStream = parseStream;
var parseFile = function parseFile(location) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fs.createReadStream(location).pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseFile = parseFile;
var parseString = function parseString(string, options) {
  var rs = new stream_1.Readable();
  rs.push(string);
  rs.push(null);
  return rs.pipe(new CsvParserStream_1.CsvParserStream(new ParserOptions_1.ParserOptions(options)));
};
exports.parseString = parseString;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vc3JjL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBR0E7QUFDQTtBQUFTO0VBQUE7RUFBQTtJQUFBLHdDQUFlO0VBQUE7QUFBQTtBQUN4QjtBQUFTO0VBQUE7RUFBQTtJQUFBLG9DQUFhO0VBQUE7QUFBQTtBQUVmLElBQU0sS0FBSyxHQUFHLFNBQVIsS0FBSyxDQUFrQyxJQUF3QixFQUEyQjtFQUNuRyxPQUFPLElBQUksaUNBQWUsQ0FBQyxJQUFJLDZCQUFhLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDdkQsQ0FBQztBQUZZLGFBQUs7QUFJWCxJQUFNLFdBQVcsR0FBRyxTQUFkLFdBQVcsQ0FDcEIsTUFBNkIsRUFDN0IsT0FBMkIsRUFDSjtFQUN2QixPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxpQ0FBZSxDQUFDLElBQUksNkJBQWEsQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDO0FBQ3ZFLENBQUM7QUFMWSxtQkFBVztBQU9qQixJQUFNLFNBQVMsR0FBRyxTQUFaLFNBQVMsQ0FDbEIsUUFBZ0IsRUFFTztFQUFBLElBRHZCLDhFQUE2QixFQUFFO0VBRS9CLE9BQU8sRUFBRSxDQUFDLGdCQUFnQixDQUFDLFFBQVEsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLGlDQUFlLENBQUMsSUFBSSw2QkFBYSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7QUFDOUYsQ0FBQztBQUxZLGlCQUFTO0FBT2YsSUFBTSxXQUFXLEdBQUcsU0FBZCxXQUFXLENBQ3BCLE1BQWMsRUFDZCxPQUEyQixFQUNKO0VBQ3ZCLElBQU0sRUFBRSxHQUFHLElBQUksaUJBQVEsRUFBRTtFQUN6QixFQUFFLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQztFQUNmLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO0VBQ2IsT0FBTyxFQUFFLENBQUMsSUFBSSxDQUFDLElBQUksaUNBQWUsQ0FBQyxJQUFJLDZCQUFhLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztBQUNuRSxDQUFDO0FBUlksbUJBQVciLCJpZ25vcmVMaXN0IjpbXX0=